import { render } from "./add-template.vue?vue&type=template&id=3ba65dee&scoped=true"
import script from "./add-template.vue?vue&type=script&lang=js"
export * from "./add-template.vue?vue&type=script&lang=js"

import "./add-template.vue?vue&type=style&index=0&id=3ba65dee&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba65dee"]])

export default __exports__